import { Injectable, inject } from '@angular/core';
import {Order} from '../classes/order';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class OrderService {
    private router = inject(Router);


    // Array
    public OrderDetails;

    // Get order items
    public getOrderItems(): Order {
        return this.OrderDetails;
    }

    // Create order
    public createOrder(product: any, details: any, orderId: any, amount: any) {
        this.OrderDetails = {
            shippingDetails: details,
            product: product,
            orderId: orderId,
            totalAmount: amount
        };
        // this.router.navigate(['/home/checkout/success']);
    }

}
